import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";

// conponents
import AnimationLoading from "../../components/Animationloading";
import EmptyComponent from "../../components/EmptyComponent";
import { GET_INDEBTED } from "../../apollo/ordergroup/query";

// apollo-client
import { useLazyQuery } from "@apollo/client";

// icons
import SearchIcon from "@mui/icons-material/Search";

// react-bootrap
import { Form, InputGroup, Card, Row, Table } from "react-bootstrap";
import "./HistoryIndebted.css";
import PaginationsV2 from "../../components/PaginationsV2";
import { IndeterminateCheckBoxSharp } from "@mui/icons-material";
import { numberFormat } from "../../helper";
// import BreadCrumbComponent from "../../components/BreadCrumbComponent";

export default function HIstoryIndebted() {
  const history = useHistory();
  const [searchText, setSearchText] = useState("");
  const [indebted, setIndebTed] = useState();
  const [totalIndebted, setTotalIndebTed] = useState();
  const [filteredIndebted, setFilteredIndebted] = useState([]);
  const sortedIndebted = filteredIndebted?.slice()?.sort((a, b) => {
    const nameA = a.customerName?.toLowerCase() || "";
    const nameB = b.customerName?.toLowerCase() || "";
    return nameA.localeCompare(nameB);
  });

  const totalBill = useMemo(() => {
    return sortedIndebted?.reduce((acc, cur) => acc + parseInt(cur.billQty), 0);
  }, [sortedIndebted]);

  // ============== > UseLazyQuery And UseMutaion <==============

  const [loadindebted, { data: GetIndebTed, loading }] = useLazyQuery(
    GET_INDEBTED,
    { fetchPolicy: "cache-first" }
  );

  // ============== > useEffect <==============

  const [page, setPage] = useState(0);

  useEffect(() => {
    if (GetIndebTed) {
      setIndebTed(GetIndebTed?.indebteds?.data);
      setTotalIndebTed(GetIndebTed?.indebteds?.total);
    }
  }, [GetIndebTed, page]);

  const rowsPerPage = 50;
  const pageAll = GetIndebTed?.indebteds?.total > 0 ? Math.ceil(GetIndebTed?.indebteds?.total / rowsPerPage) : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  useEffect(() => {
    if (indebted && searchText) {
      const filteredData = indebted.filter((item) =>
        item.customerName?.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredIndebted(filteredData);
    } else {
      setFilteredIndebted(indebted);
    }
  }, [indebted, searchText, page]);

  useEffect(() => {
    _fetchIndebTed();
  }, [searchText, page]);

  // ============== > fuctions <==============

  const _fetchIndebTed = async () => {
    let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    let _where = {
      shop: shopId,
      isDeleted: false,
      status: "INDEBTED",
      // orderBy: "createdAt_ASC"
    };

    await loadindebted({
      variables: {
        // limit: 10,
        skip: page * rowsPerPage,
        limit: rowsPerPage,
        where: _where,
      },
    });
  };

  const handleDetailIndebted = (id, state) => {
    history.push("/indebted_detail/" + id, { state });
  };

  return (
    <React.Fragment>
      <div  style={{ padding: "1em 1.5em" }}>
      
        <div className="header-section">
          <h4 className="page-title">
            <b>ປະຫວັດການ ຄ້າງໜີ້</b>
          </h4>
          <p className="page-description">
            ປະຫວັດອໍເດີ້ທີ່ລູກຄ້າຕິດໜິ້ໄວ້
          </p>
          
          {/* Statistics Cards */}
          <div className="stats-container">
            <div className="stat-card">
              <div className="stat-icon customers-icon">
                <i className="fas fa-users"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{totalIndebted || 0}</h3>
                <p className="stat-label">ລູກຄ້າທັງໝົດ</p>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon bills-icon">
                <i className="fas fa-file-invoice"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{totalBill || 0}</h3>
                <p className="stat-label">ບີນທັງໝົດ</p>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon items-icon">
                <i className="fas fa-box"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{GetIndebTed?.indebteds?.totalAmount || 0}</h3>
                <p className="stat-label">ລາຍການສີນຄ້າ</p>
              </div>
            </div>
            
            <div className="stat-card highlight-card">
              <div className="stat-icon amount-icon">
                <i className="fas fa-money-bill-wave"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{numberFormat(GetIndebTed?.indebteds?.totalSumPrice) || '0'}</h3>
                <p className="stat-label">ຍອດເງີນທັງໝົດ (LAK)</p>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
          marginBottom: "1em",
          }}>
          <Form.Label>ຊອກຫາ</Form.Label>
              <InputGroup style={{ width: "100%", maxWidth: 300 }}>
                <InputGroup.Text
                  style={{
                    backgroundColor: "#FFFFFF", 
                  }}>
                  <SearchIcon sx={{ color: "#6B7280" }} />
                </InputGroup.Text>
                <Form.Control
                  placeholder="ປ້ອນລາຍຊື່ລູກຄ້າ..."
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  value={searchText}
                  style={{
                    borderLeft: "none",
                  }}
                />
              </InputGroup>
        </div>
        {loading && !GetIndebTed ? (
          <AnimationLoading />
        ) : (
          <Card>
            <Table
              hover
              style={{
                borderCollapse: "collapse",
                width: "100% ",
              }}>
              <thead>
                <tr>
                  <th>ລຳດັບ</th>
                  <th>ຊື່ລູກຄ້າ</th>
                  <th>ນາມສະກຸນ</th>
                  <th>ເບີໂທຕິດຕໍ່</th>
                  <th>ຈຳນວນບິນ</th>
                  <th>ຍອດສີນຄ້າ</th>
                  <th>ຍອດເງີນ</th>
                </tr>
              </thead>
              <tbody>
                {sortedIndebted?.map((indebteds, index) => (
                  <tr key={IndeterminateCheckBoxSharp}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleDetailIndebted(indebteds?.customerId, indebteds)
                    }>
                    <td>{page * rowsPerPage + index + 1}</td>
                    <td>{indebteds?.customerName ?? "-"}</td>
                    <td>{indebteds?.customerLastName ?? "-"}</td>
                    <td>{indebteds?.phone ?? "-"}</td>
                    <td>{indebteds?.billQty ?? "0"}</td>
                    <td>{indebteds?.amount || '0'}</td>
                    <td>{numberFormat(indebteds?.sumPrice) ?? "0"} LAK</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        )}
        <div style={{ marginTop: ".8em" }}>
          <PaginationsV2
            count={GetIndebTed?.indebteds?.total}
            rowsPerPage={rowsPerPage}
            page={page}
            pageAll={pageAll}
            onPageChange={handleChangePage}
          />
        </div>
        {sortedIndebted?.length <= 0 && (
          <div
            style={{
              fontSize: "24px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "#6B7280",
              fontWeight: "400",
            }}>
            <EmptyComponent />
            <p>ຍັງບໍ່ມີປະຫວັດການຕິດໜີ້ !!!</p>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
